// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-PatientPage-__styles__container--CgBmm","backButton":"src-components-PatientPage-__styles__backButton--1lZMl","panelContainer":"src-components-PatientPage-__styles__panelContainer--39XaZ","panel":"src-components-PatientPage-__styles__panel--ZcJfz"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PatientPage/styles.css
// module id = 2000
// module chunks = 0